import { Divider } from "@mantine/core"
import { DetailsCard } from "../../../-components/details-card"
import { DefaultList } from "../../../../../-components/default-list"
import {
  LabeledValueProps,
  LabeledValue,
} from "../../../../../-components/default-list/labeled-value"
import { DefaultListItem } from "../../../../../-components/default-list/list-item"
import { Page } from "../../../../../-components/Page"
import { useSuspenseQueryGet } from "../../../../../typed-client/hooks/use-suspense-query-get"
import { getFormattedDate } from "../../../../../utils/get-formatted-date"
import { Route } from "../$id"

function RenderProperties({ logEvent }: { logEvent: string }) {
  const obj = JSON.parse(logEvent)
  if (obj === null || typeof obj !== "object") {
    return null
  }
  if (obj["Properties"] && typeof obj["Properties"] === "object") {
    const entries: LabeledValueProps[] = Object.entries(obj["Properties"]).map(
      ([key, value]) => ({
        label: key,
        value: typeof value === "string" ? value : JSON.stringify(value),
      })
    )
    return (
      <DefaultList
        divider
        data={entries}
        renderItem={({ entity: props }) => (
          <DefaultListItem>
            <LabeledValue {...props} />
          </DefaultListItem>
        )}
        itemRenderCondition={(item) => item.value}
      />
    )
  }

  return null
}

export function LogPage() {
  const id = parseInt(Route.useParams().id)
  const { data: log } = useSuspenseQueryGet("/api/Log/GetLog", { id })

  const logDetails: LabeledValueProps[] = [
    { label: "ID", value: log.id },
    {
      label: "Time stamp",
      value: getFormattedDate(log.timeStamp, "L LTS"),
    },
    { label: "Level", value: log.level },
    { label: "Username", value: log.user?.userName },
    ...(log.exception ? [{ label: "Exception", value: log.exception }] : []),
  ]

  return (
    <Page>
      <DetailsCard title="Log" stackProps={{ mah: undefined, id: "log" }}>
        <DefaultList
          divider
          data={logDetails}
          renderItem={({ entity: props }) => (
            <DefaultListItem>
              <LabeledValue {...props} />
            </DefaultListItem>
          )}
          itemRenderCondition={(item) => item.value}
        />
        <Divider label="Properties" my="xl" labelPosition="left" />

        <RenderProperties logEvent={log.logEvent} />
      </DetailsCard>
    </Page>
  )
}
